import { render, staticRenderFns } from "./LancamentoDetalhes.vue?vue&type=template&id=637a5e56&"
import script from "./LancamentoDetalhes.vue?vue&type=script&lang=js&"
export * from "./LancamentoDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./LancamentoDetalhes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports